module.exports = __webpack_public_path__ + "static/media/edit.92631c49.svg";